
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch-challenge",
      function () {
        return require("private-next-pages/launch-challenge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch-challenge"])
      });
    }
  